import MainLayout from "../layouts/MainLayout";
import Breadcrumbs from "../components/portfolio/Breadcrumbs";
import PortfolioFilters from "../components/portfolio/PortfolioFilters";
import PortfolioItem from "../components/portfolio/PortfolioItem";
import { useLightbox } from "../hooks/useLightbox";
import { portfolioItems } from "../data/portfolioData";
import "glightbox/dist/css/glightbox.min.css";

const Work = () => {
  useLightbox();

  return (
    <MainLayout page="work">
      <Breadcrumbs />
      <section id="portfolio" className="portfolio">
        <div className="container">
          <PortfolioFilters />
          <div className="row portfolio-container">
            {portfolioItems.map((item, index) => (
              <PortfolioItem key={index} item={item} />
            ))}
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default Work;
